module.exports = __webpack_public_path__ + "static/media/alfa3.23658510.png";